import { useRef } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import config from './config'
import { apiData2Table } from '@/utils/data.ts'
import { message } from 'antd'
import {beforeClueResend, getBeforeCluePage} from "@/services/saleOpServices.ts";
import {getEnums} from "@/services/homeService.ts";
const PreDispatchList = () => {
  const listRef = useRef<any>()

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const params = {
          ...query,
          orderBys:[{ columnName: 'createdTime', asc: false }, { columnName: 'id', asc: false }],
        }
        getBeforeCluePage({params: { pageId:current,pageSize}, data:{...params}}).then(res => {
          resolve(apiData2Table(res))
        })
      } catch {
        reject({ success: false })
      }
    })
  }

  const getStatusOptions = () => {
    return new Promise( async (resolve) => {
      const statusList = await getEnums('plus-clue', 'com.shj.saas.plus.clue.enums.BaseClueStatus')
      resolve({
        statusList,
      })
    })
  }

  const onPush = (record: any) => {
    beforeClueResend(record?.id).then((res: any) => {
      message.success(res.message || '推送成功')
      listRef?.current?.reload()
    })
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    // auth: authMap,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(_text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              confirm
              disabled={record?.status === 'SUCCESS'}
              title="确认推送?"
              onClick={() => onPush(record)}
            >
              手动推送入库
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
    </>
  )
}

export default PreDispatchList
